var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-page',{staticClass:"show-settings-subscribe-links",attrs:{"show":_vm.show},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var formProcessing = ref.formProcessing;
var onSubmit = ref.onSubmit;
return [_c('subscribe-links',{attrs:{"show":_vm.show,"form-processing":formProcessing},on:{"submit":onSubmit}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }